// EditedPhoto.jsx – zeigt ein Foto mit Ausschnitt, Drehung und Farbkorrektur (per CSS)
// Füllt den Elternrahmen. Ist der Rahmen nicht quadratisch, wird das quadratische Foto mittig angezeigt:
//   fit="cover"   → füllt den Rahmen, oben/unten bzw. links/rechts beschnitten
//   fit="contain" → ganzer gewählter Ausschnitt sichtbar, Rest des Rahmens bleibt leer
import React from 'react';
import { layoutPercent } from '../utils/photoEdit';

export function EditedPhoto({ photo, edit, alt = '', className = '', style, fit = 'cover' }) {
  if (!photo) return null;
  const side = fit === 'contain' ? 'min(100cqw, 100cqh)' : 'max(100cqw, 100cqh)';
  if (!edit && fit === 'contain') {
    // noch nicht bearbeitet: gleicher Standard-Ausschnitt wie beim Druck (quadratisch, Hochformat etwas oben)
    return (
      <div className={className} style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden', containerType: 'size', ...style }}>
        <img src={photo} alt={alt} draggable={false}
          style={{ position: 'absolute', left: '50%', top: '50%', width: side, height: side, transform: 'translate(-50%, -50%)',
            objectFit: 'cover', objectPosition: '50% 25%', display: 'block', userSelect: 'none', pointerEvents: 'none' }} />
      </div>
    );
  }
  if (!edit) {
    return (
      <img src={photo} alt={alt} className={className} draggable={false}
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', ...style }} />
    );
  }
  const l = layoutPercent(edit);
  return (
    <div className={className} style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden', containerType: 'size', ...style }}>
      {/* quadratische Bühne (Seitenlänge = grössere Rahmenseite), mittig im Rahmen */}
      <div style={{ position: 'absolute', left: '50%', top: '50%', width: side, height: side, transform: 'translate(-50%, -50%)', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', ...l.layer }}>
          <img src={photo} alt={alt} draggable={false}
            style={{ position: 'absolute', maxWidth: 'none', userSelect: 'none', pointerEvents: 'none', ...l.img }} />
        </div>
      </div>
    </div>
  );
}
